import { LANDING_QUIZ_ITEMS } from '@/constants/landingQuiz'

/** Ответы квиза → поля CRM для sendLeadEvent. */
export function buildCrmFieldsFromQuiz(quizAnswers) {
  const multiToStr = (key) => {
    const raw = quizAnswers[key]
    if (Array.isArray(raw)) return raw.join(', ')
    return String(raw ?? '').trim()
  }

  const contactChannel = quizAnswers.contact_channel || ''
  const preferred = ['phone']
  if (contactChannel === 'telegram') preferred.push('telegram')
  if (contactChannel === 'email') preferred.push('email')

  return {
    name: String(quizAnswers.name ?? '').trim(),
    phone: String(quizAnswers.phone ?? '').trim(),
    company: String(quizAnswers.company ?? '').trim(),
    email: String(quizAnswers.email ?? '').trim(),
    telegram: String(quizAnswers.telegram ?? '').trim(),
    preferred_contact_channels: preferred,
    role: quizAnswers.role || '',
    products: quizAnswers.products || '',
    tender_interest: quizAnswers.tender_interest || '',
    regions: quizAnswers.regions || '',
    procurement_types: multiToStr('procurement_types'),
    tenders_per_month: quizAnswers.tenders_per_month || '',
    has_tender_specialist: quizAnswers.has_tender_specialist || '',
    current_tools: multiToStr('current_tools'),
    main_problem: quizAnswers.main_problem || '',
    needs: multiToStr('needs'),
    keyword_query: [quizAnswers.products, quizAnswers.tender_interest].filter(Boolean).join('; '),
    quiz_answers: { ...quizAnswers },
  }
}

/** Массив { question, answer } для аналитики / AI. */
export function buildFunnelAiAnswers(quizAnswers) {
  const items = []
  for (const step of LANDING_QUIZ_ITEMS) {
    if (step.type === 'consent') continue
    const raw = quizAnswers[step.id]
    if (step.type === 'multi') {
      const list = Array.isArray(raw) ? raw : []
      if (list.length) items.push({ question: step.question, answer: list.join(', ') })
      continue
    }
    if (step.type === 'contact') {
      const channel = quizAnswers.contact_channel
      const detail =
        channel === 'telegram'
          ? quizAnswers.telegram
          : channel === 'email'
            ? quizAnswers.email
            : ''
      if (channel) {
        items.push({
          question: step.question,
          answer: [channel, detail].filter(Boolean).join(': '),
        })
      }
      continue
    }
    const text = String(raw ?? '').trim()
    if (text) items.push({ question: step.question, answer: text })
  }
  return items
}

export function usesTenderplanInQuiz(quizAnswers) {
  const tools = quizAnswers?.current_tools
  if (!Array.isArray(tools)) return false
  return tools.some((t) => String(t).toLowerCase().includes('tenderplan'))
}
